import column from "../../partials/column";

const footer = {
  name: "footer",
  label: "Footer Links",
  file: "content/setting/footer.md",

  fields: [
    {
      label: "Template",
      name: "template",
      widget: "hidden",
      default: "footer",
      required: true,
    },
    column("left", "Left"),
    column("middle", "Middle"),
    column("right", "Right"),
    {
      label: "Copyright",
      name: "copyright",
      widget: "string",
      default: "©2023 2459 Poulton-le-Fylde Squadron RAFAC. UK Crown Copyright",
      required: true,
    },
  ],
};
export default footer;
